import { Input as ChakraInput } from '@chakra-ui/react';

export const Input = ChakraInput;
